import { render } from "./MensajesPredefinidosLista.vue?vue&type=template&id=49895395"
import script from "./MensajesPredefinidosLista.vue?vue&type=script&lang=js"
export * from "./MensajesPredefinidosLista.vue?vue&type=script&lang=js"

import "./MensajesPredefinidosLista.vue?vue&type=style&index=0&id=49895395&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__